import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import {
  FDLabelText, FDStack,
} from '@facet-wealth/design';
import { CondensedListItem } from 'Packages/FacetDesign/Components/Experimental/CondensedListItem';
import {
  IS_STARRED_QUERY_FIELD, IS_UNREAD_QUERY_FIELD,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadListHeader/components/ThreadListFilters';

const FrequentlyUsedFilterGroup = ({
  resource, onChange, handleClose,
}) => {
  return (
    <FDStack direction={'column'} spacing={2}>
      <FDLabelText value={'Frequently Used'} />
      <FDStack direction={'column'} spacing={1}>
        <CondensedListItem
          primaryText={resource.meta().field(IS_UNREAD_QUERY_FIELD).attr('prompt')}
          onClick={() => {
            onChange(!resource.isTruthy(IS_UNREAD_QUERY_FIELD), IS_UNREAD_QUERY_FIELD);
            handleClose();
          }}
          test={'unread-filter-item'}
        />
        <CondensedListItem
          primaryText={resource.meta().field(IS_STARRED_QUERY_FIELD).attr('prompt')}
          onClick={() => {
            onChange(!resource.isTruthy(IS_STARRED_QUERY_FIELD), IS_STARRED_QUERY_FIELD);
            handleClose();
          }}
        />
      </FDStack>
    </FDStack>
  );
};

FrequentlyUsedFilterGroup.defaultProps = {
};

FrequentlyUsedFilterGroup.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  handleClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export {
  FrequentlyUsedFilterGroup,
};
